import { Component, OnInit, HostListener, ViewEncapsulation } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.sass'],
	encapsulation: ViewEncapsulation.None,
	animations: [
		trigger('slideInOut', [
			state('in', style({
				height: '*',
				overflow: 'hidden',
			})),
			state('out', style({
				height: '0px',
				overflow: 'hidden',
			})),
			transition('in => out', animate('500ms ease-in')),
			transition('out => in', animate('500ms ease-in')),
		])
	]
})
export class HeaderComponent implements OnInit {

	servicesMenuOpen: string;
	pricesMenuOpen: string;
	philatelyMenuOpen: string;
	dliaBiznesuMenuOpen: string;

	// unique for footer and header
	wwwContent: string = 'www.';

	constructor() { }

	ngOnInit () {
		this.servicesMenuOpen = 'out';
		this.pricesMenuOpen = 'out';
		this.philatelyMenuOpen = 'out';
		this.dliaBiznesuMenuOpen = 'out';
	}

	toggleServicesDropdown(): void {
		this.servicesMenuOpen = this.servicesMenuOpen === 'out' ? 'in' : 'out';
		this.pricesMenuOpen = 'out';
		this.philatelyMenuOpen = 'out';
		this.dliaBiznesuMenuOpen = 'out';
	}

	togglePricesDropdown(): void {
		this.pricesMenuOpen = this.pricesMenuOpen === 'out' ? 'in' : 'out';
		this.servicesMenuOpen = 'out';
		this.philatelyMenuOpen = 'out';
		this.dliaBiznesuMenuOpen = 'out';
	}

	togglePhilatelyDropdown(): void {
		this.philatelyMenuOpen = this.philatelyMenuOpen === 'out' ? 'in' : 'out';
		this.servicesMenuOpen = 'out';
		this.pricesMenuOpen = 'out';
		this.dliaBiznesuMenuOpen = 'out';
	}
	
	toggleDliaBiznesuDropdown(): void {
		this.dliaBiznesuMenuOpen = this.dliaBiznesuMenuOpen === 'out' ? 'in' : 'out';
		this.servicesMenuOpen = 'out';
		this.pricesMenuOpen = 'out';
		this.philatelyMenuOpen = 'out';
	}

	hideDropDownMenu(): void {
		this.servicesMenuOpen = 'out';
		this.pricesMenuOpen = 'out';
		this.philatelyMenuOpen = 'out';
		this.dliaBiznesuMenuOpen = 'out';
	}

	@HostListener('document:click', []) onDocumentClick() {  // '$event'
		this.servicesMenuOpen = 'out';
		this.pricesMenuOpen = 'out';
		this.philatelyMenuOpen = 'out';
		this.dliaBiznesuMenuOpen = 'out';
	}

	showMobileMenu() {
		document.getElementsByClassName('mobile-menu')[0].classList.add('active-mobile-menu');
	}

	hideMobileMenu() {
		document.getElementsByClassName('mobile-menu')[0].classList.remove('active-mobile-menu');
	}

}
